import { CommonModule } from '@angular/common';
import { Component, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { getEntityConfig, type EntityConfig } from '../../config/entity-config';
import { EntityCreatePageComponent } from '../entity-create/entity-create-page.component';

/**
 * Route component for /manage/:entityKey/new. Renders custom create or default EntityCreatePageComponent.
 */
@Component({
  selector: 'app-management-create',
  standalone: true,
  imports: [CommonModule, EntityCreatePageComponent],
  template: `
    @if (entityConfig(); as config) {
      @if (config.createComponent) {
        <ng-container *ngComponentOutlet="config.createComponent; inputs: { entityConfig: config }" />
      } @else {
        <app-entity-create-page [entityConfig]="config" />
      }
    } @else {
      <p>Unknown entity.</p>
    }
  `,
})
export class ManagementCreateComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private sub: Subscription | null = null;
  readonly entityConfig = signal<EntityConfig | undefined>(undefined);

  ngOnInit(): void {
    this.sub = this.route.paramMap.subscribe((params) => {
      const key = params.get('entityKey') ?? '';
      this.entityConfig.set(getEntityConfig(key));
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
